module.exports = __webpack_public_path__ + "static/media/funchal-10.d0f36ac3.jpg";